'use client';

import React, { memo } from 'react';

interface BannerCarouselPagingProps {
  index: number;
  activeSlide: number;
  onSlideChange: (currentSlide: number) => void;
}

const BannerCarouselPaging = ({ index, activeSlide, onSlideChange }: BannerCarouselPagingProps) => {
  return (
    <div
      // role="button"
      className={`v2-inline-block v2-h-3 v2-w-3 v2-cursor-pointer v2-rounded-full v2-transition-all v2-duration-300 md:v2-h-[15px] md:v2-w-[15px] ${
        index === activeSlide ? 'v2-bg-primary' : 'v2-bg-[#A7BAB3]'
      } `}
      onClick={() => onSlideChange(index)}
    ></div>
  );
};

export default memo(BannerCarouselPaging);
